//google
export const url_path_images =
  "https://storage.googleapis.com/ansx/website/images/";
export const url_upload_images = "https://dash.api.anousith-express.com/images";

export const url_path_files =
  "https://storage.googleapis.com/anousith-bucket/user-register/";
export const url_upload_files =
  "https://api.services.anousith.express/google/upload";

// export const url_upload_files = " http://localhost:4500/files";http://192.168.0.186:4500/
